const getters = {
    token:state=>state.user.token,
    isLoginMode:state=>state.user.isLoginMode,
    userInfo:state=>state.user.userInfo,
    baseUrl:state=>state.user.baseUrl,
}

export default getters